/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Bump_SaveInputs */

const cs_portals_bump_save = /** @type {(inputs: Portals_Bump_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uložit bump`)
};

const en_portals_bump_save = /** @type {(inputs: Portals_Bump_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save bump`)
};

/**
* | output |
* | --- |
* | "Save bump" |
*
* @param {Portals_Bump_SaveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_bump_save = /** @type {((inputs?: Portals_Bump_SaveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Bump_SaveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_bump_save(inputs)
	return cs_portals_bump_save(inputs)
});